import React, { useState, useEffect } from 'react'

import { useDateFilter, useFilterTransactions, useSearchFilter, useSelectFilter } from '../../../utils/filterutils'
import { useExpandRows, useSortTransactions } from '../../../utils/tablehooks'
import { FetchDeleteTransactionDraft } from '../../../fetcher'
import { enumvaluetranslations } from '../../../utils/enumvaluetranslations';
import { StateSelect, DateSelect } from '../../../utils/filterutils'
import { OutgoingTransactionsHeaderView, OutgoingTransactionsTableView } from './OutgoingTransactionsView'

/**
 * Container Component for managing table states. 
 * Manages all table related actions, such as´filtering. Returns the transaction views
 * @param {object[]} outgoingTransactions array of outgoing transactions
 * @param {any} openAlert opens an alert message
 * @param {any} reload handles the parent components relad
 * @param {any} setDraftToUpdate sets the updated value of a draft to true
 * @param {any} handleShowMaskDeliveryDraft handles visibility for transaction draft input
 * @param {any} handleShowMaskDelivery handles visibility for transaction input
 * @param {any} handleShowCorrectionModal handles visibility of a modal for corrections
 */
const OutgoingTransactionsTableContainer = ({ outgoingTransactions, openAlert, reload, setDraftToUpdate, handleShowMaskDeliveryDraft, handleShowMaskDelivery, handleShowCorrectionModal }) => {

    const [filterable, setFilterable] = useState(false)
    const [filteredOutgoingTransactions, setFilteredOutgoingTransactions] = useState([])
    const [sortedOutgoingTransactions, setSortedOutgoingTransactions] = useState([])
    const [filterArticles, setFilterArticles] = useState(false)
    const toggleFilterArticles = () => {
        setFilterArticles(!filterArticles)
    }

    const { expandRow, getIsExpandedRow } = useExpandRows()
    const { sortTransactions } = useSortTransactions(outgoingTransactions, setSortedOutgoingTransactions)
    const { filterTransactionsBySearchInput, filterTransactionsAndArticlesBySearchInput, filterTransactionsByDateInput, filterTransactionsBySelectInput } = useFilterTransactions()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [ statusSelect, handleStatusSelectChange ] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    /**
     * UseEffect hook resets filtered transactions every time the original data changes
    */
    useEffect(() => {
        setFilteredOutgoingTransactions([...outgoingTransactions])
    }, [outgoingTransactions])

    const takeSortedTransactions = () => {
        //Maybe this shouldn't be done in general, as there should be another option to deep clone an object!
        let deepCopy = JSON.parse(JSON.stringify(sortedOutgoingTransactions))
        return deepCopy
    }

    /**
     * UseEffect hook that filters the transactions.
     * Executed every time one of the filter/selection inputs changes.
    */
    useEffect(() => {
        let filteredTransactions = filterArticles ? filterTransactionsAndArticlesBySearchInput(takeSortedTransactions(), searchInput) : filterTransactionsBySearchInput(sortedOutgoingTransactions, searchInput)
        filteredTransactions = filterTransactionsByDateInput(filteredTransactions, dateSelect)
        filteredTransactions = filterTransactionsBySelectInput(filteredTransactions, statusSelect)

        setFilteredOutgoingTransactions(filteredTransactions)
    }, [searchInput, dateSelect, statusSelect, sortedOutgoingTransactions, filterArticles])

    /**
     * Removes a selected transaction draft. Calls a fetch method and reloads after deletion.
     * @param {any} e the click event
     * @param {string} transactionDraft the unique transactionSysId
     */
    const removeTransactionDraft = (e, transactionDraft) => {
        e.preventDefault()
        FetchDeleteTransactionDraft(transactionDraft, openAlert, reload)
    }

    /**
     * Opens a mask 
     * @param {any} e the click event
     * @param {any} transactionDraft the unique transactionSysId
     */
    const updateTransactionDraft = (e, transactionDraft) => {
        e.preventDefault()
        setDraftToUpdate(transactionDraft)
        handleShowMaskDeliveryDraft()
    }

    /**
     * Toggles the filterable value; indicates if filter menu is opened
    */
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    /**
     * Sorts the transactions passed into "useSortTransactions" hook after field value
     * @param {any} e click event
     * @param {string} field property to sort after
     */
    const handleSortTransactions = (e, field) => {
        e.preventDefault()
        sortTransactions(field)
    }

    return (
        <>
            <OutgoingTransactionsHeaderView handleShowMaskDelivery={handleShowMaskDelivery} handleSearchInput={handleSearchInput} setFilterbar={setFilterbar} filteredOutgoingTransactions={filteredOutgoingTransactions} filterArticles={filterArticles} toggleFilterArticles={toggleFilterArticles}/>
            <OutgoingTransactionsTableView filteredOutgoingTransactions={filteredOutgoingTransactions} DateSelect={DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)} StateSelect={StateSelect([...new Set(outgoingTransactions.map(x => enumvaluetranslations(x.State)))], handleStatusSelectChange, statusSelect)}
                filterable={filterable} updateTransactionDraft={updateTransactionDraft} removeTransactionDraft={removeTransactionDraft} handleShowCorrectionModal={handleShowCorrectionModal} getIsExpandedRow={getIsExpandedRow} expandRow={expandRow} handleSortTransactions={handleSortTransactions} />
        </>
    )
}

export { OutgoingTransactionsTableContainer }